import React from 'react';
import styled, {css} from 'styled-components';

import Icon, {IconSize} from '../../../Icon/Icon';
import {
  GenericIconName,
  ShippingDestinationCountryFlag,
} from '../../../Icon/IconName';

interface Props {
  flag: ShippingDestinationCountryFlag;
  name: string;
  selected: boolean;
}

const FlagIcon = styled(Icon)`
  margin-right: 0.5rem;
`;

const Row = styled.div<{selected: boolean}>`
  height: 100%;
  width: 100%;
  margin-left: -15px;
  padding: 0 15px 0 15px;
  justify-content: flex-start;
  align-items: center;
  display: flex;
  box-shadow: 0 -1px 0 0 var(--grey-3);
  ${({selected}) =>
    selected &&
    css`
      box-shadow: 0 1.5px 0 0 var(--black), 0 -1.5px 0 0 var(--black);
      & :last-child {
        margin-left: auto;
      }
    `}
`;

export const CountryRowItem = ({flag, name, selected}: Props) => {
  return (
    <Row selected={selected}>
      <FlagIcon size={IconSize.XS} asset={flag} />
      {name}
      {selected && <Icon asset={GenericIconName.IcClose} size={IconSize.XS} />}
    </Row>
  );
};
